import { SendOTPDto, SendOTPDtoImpl } from './sendotpdto';
import { NoDataException } from '../../../../utils/exceptions/nodataexistsexception';

export class SendOTPBuilder {
    constructor(private sendOTPResponse: any) {
        if(sendOTPResponse === undefined)
        {
            throw new NoDataException("Send otp data doesnt exists");
        }
    }

    buildAll(): SendOTPDto {
        return this.parseSendOTPResponse();
    }

    private parseSendOTPResponse(): SendOTPDto {
        let sendOTPResponseItem = this.sendOTPResponse;

        let sendOTPDto = null;
        sendOTPDto = new SendOTPDtoImpl();
        sendOTPDto.setRespCode(sendOTPResponseItem.respCode);
        sendOTPDto.setRespDesc(sendOTPResponseItem.respDesc);
        sendOTPDto.setSrvType(sendOTPResponseItem.srvType);
        sendOTPDto.setSecToc(sendOTPResponseItem.secToc);

        return sendOTPDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpbuilder.ts